<template>
  <div class="form-item form-item_w100">
    <input
      type="text"
      ref="autocomplete"
      @focus="geolocate"
      @blur="blur"
      class="autocomplete__input"
      :placeholder="placeholder"
      v-model="value"
      id="autocomplete"
      :disabled="disabled"
      :class="{
              'disabled-input': disabled
          }"
    />
  </div>
</template>

<script>
export default {
  name: "autocomplete-input",
  props: {
    autocompleteValue: {
      required: false,
      type: String,
      default: ""
    },
    clear: {
      required: false,
      default: false
    },
    isUpdate: {
      required: false,
      default: false
    },
    placeholder: {
      required: false,
      default: "Enter address"
    },
    disabled: {
      required: false,
      default: false
    },
    autofocus: {
      required: false,
      default: false
    },
    geolocation: {
      required: false,
      default: true
    },
    fields: {
      required: false,
      default: () => ["address_component", "geometry"]
    }
  },
  watch: {
    clear(v) {
      if (v) {
        this.clearInput();
      }
    },
    isUpdate(v) {
      if (v) {
        this.value = this.autocompleteValue;
      }
    },
    value(v) {
      if (v == "") {
        this.$emit("resetErrors");
      }
    }
  },
  data() {
    return {
      autocomplete: null,
      rules: ["route", "street_number", "postal_code", "locality", "country"],
      result: [],
      data: null,
      allowSave: false,
      autocompleteListener: null,
      value: ""
    };
  },
  methods: {
    getCountry() {
      return this.$config.project == "hilfy" ? ["at"] : ["de"];
    },
    initInput() {
      if (window.google != undefined) {
        this.autocomplete = new window.google.maps.places.Autocomplete(
          this.$refs["autocomplete"],
          { types: ["geocode"] }
        );

        this.autocomplete.setComponentRestrictions({
          country: this.getCountry()
        });

        this.autocomplete.setFields(this.fields);

        this.autocompleteListener = window.google.maps.event.addListener(
          this.autocomplete,
          "place_changed",
          () => {
            this.fillInAddress();
          }
        );
      }
    },
    fillInAddress() {
      this.result = [];
      const places = this.autocomplete.getPlace();

      if (places.place_id) {
        this.$emit("fill", {
          place_id: places.place_id
        });
        return;
      }

      places.address_components.forEach(element => {
        if (this.rules.lastIndexOf(element.types[0]) != -1) {
          this.result.push(element);
        }
      });

      if (places.address_components.length < 7) {
        this.$emit("errorInput");
        return;
      }

      if (this.result[4] == undefined) {
        this.$emit("errorInput");
        return;
      }

      const address = {
        postcode: this.result[4].long_name,
        country: this.result[3].long_name,
        city: this.result[2].short_name,
        street: this.result[1].short_name,
        house: parseInt(this.result[0].short_name) + "",
        entrance: 1 + "",
        apartment: 1 + "",
        description: "",
        longitude: places.geometry.location.lng(),
        latitude: places.geometry.location.lat(),
        place_id: places.place_id
      };

      this.allowSave = true;

      this.$emit("fill", {
        address,
        autocompleteValue: this.value
      });
    },
    geolocate() {
      if (!this.geolocation) return;

      if (
        window.navigator.geolocation &&
        window.google != undefined &&
        this.autocomplete != undefined
      ) {
        window.navigator.geolocation.getCurrentPosition(position => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          var circle = new window.google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          });

          this.autocomplete.setBounds(circle.getBounds());
        });
      }

      this.$emit("focus");
    },
    clearInput() {
      this.value = "";
      this.autocompleteValue = "";
    },
    getValue() {
      if (this.value == "") {
        this.$emit("clearInput");
      }
    },
    blur() {
      if (this.value.trim() == "") {
        this.$emit("blur", this.value);
      }
    }
  },
  mounted() {
    this.initInput();
    this.value = this.autocompleteValue;

    if (this.autofocus) {
      this.$refs["autocomplete"].focus();
    }
  },
  destroyed() {
    window.google.maps.event.removeListener(this.autocompleteListener);
    window.google.maps.event.clearInstanceListeners(this.autocomplete);

    if (document.querySelector(".pac-container")) {
      document.querySelector(".pac-container").remove();
    }
  }
};
</script>

<style scoped>
.autocomplete__input {
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
}
</style>